export const TEAMS_CHANNEL_URL_ERROR =
  "Teams Channel URL must be a Teams Channel link containing channelId and groupId.";

export const TEAMS_TEAM_URL_ERROR =
  "This is a Teams URL, not a Teams Channel URL. Please open a specific channel in Teams and copy its link.";

export interface TeamsChannelUrlInfo {
  teamId: string;
  channelId: string;
  /** 仅来自 URL 路径，不代表通过 Graph 查询到的实时 displayName。 */
  channelNameFromUrl: string;
}

function parseTeamsUrl(value: string): URL | null {
  try {
    const url = new URL(value.trim());
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    const hostname = url.hostname.toLowerCase();
    if (hostname !== "teams.microsoft.com" && !hostname.endsWith(".teams.microsoft.com")) {
      return null;
    }
    return url;
  } catch {
    return null;
  }
}

function decodeRepeatedly(value: string): string {
  let current = value;
  for (let index = 0; index < 2; index += 1) {
    try {
      const decoded = decodeURIComponent(current);
      if (decoded === current) break;
      current = decoded;
    } catch {
      break;
    }
  }
  return current;
}

function getQueryValue(url: URL, name: string): string {
  let result = "";
  for (const part of url.search.slice(1).split("&")) {
    const separatorIndex = part.indexOf("=");
    if (separatorIndex < 0) continue;

    const key = decodeRepeatedly(part.slice(0, separatorIndex));
    if (key.toLowerCase() !== name.toLowerCase()) continue;

    result = decodeRepeatedly(part.slice(separatorIndex + 1).replace(/\+/g, " "));
  }
  return result;
}

export function parseTeamsChannelUrl(value: string): TeamsChannelUrlInfo | null {
  const url = parseTeamsUrl(value);
  if (!url) return null;

  const segments = url.pathname.split("/").filter(Boolean).map(decodeRepeatedly);
  const channelIndex = segments.findIndex((segment) => segment.toLowerCase() === "channel");
  if (channelIndex < 0) return null;

  const channelId = segments[channelIndex + 1]?.trim();
  const teamId = getQueryValue(url, "groupId").trim();
  if (!channelId || !teamId) return null;

  return {
    teamId,
    channelId,
    channelNameFromUrl: segments[channelIndex + 2]?.trim() ?? "",
  };
}

export function isTeamsTeamUrl(value: string): boolean {
  const url = parseTeamsUrl(value);
  if (!url) return false;
  const segments = url.pathname.split("/").filter(Boolean);
  return segments.some(
    (segment, index) =>
      segment.toLowerCase() === "team" && segments[index - 1]?.toLowerCase() === "l",
  );
}

export function isTeamsChannelUrl(value: string): boolean {
  return parseTeamsChannelUrl(value) !== null;
}

export function getTeamsChannelName(value: string): string {
  return parseTeamsChannelUrl(value)?.channelNameFromUrl ?? "";
}

export function getTeamsChannelUrlError(value: string): string {
  return isTeamsTeamUrl(value) ? TEAMS_TEAM_URL_ERROR : TEAMS_CHANNEL_URL_ERROR;
}
